(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomRouteTypeAttributeDetailController', CustomRouteTypeAttributeDetailController);

    CustomRouteTypeAttributeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomRouteTypeAttribute'];

    function CustomRouteTypeAttributeDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomRouteTypeAttribute) {
        var vm = this;

        vm.customRouteTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:customRouteTypeAttributeUpdate', function(event, result) {
            vm.customRouteTypeAttribute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
